<template>
  <div style="margin-left: 40px;margin-right: 40px;">
    <div class="source" >
      <el-row class="querypanel">
        <el-col :span="12"><div class="queryinput">
          <el-input v-model="query_brand" placeholder="请输入品牌名称"></el-input>
        </div>
        </el-col>
        <el-col :span="12" class="queryinput">
          <div>
            <el-button @click="queryinfo">查询</el-button>
            <el-button @click="append">创建新品牌</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="tablepanel">
            <el-table
              v-loading="loading"
              :data="goodsbrandtb"
              highlight-current-row
              fit
              ref="multipleTable"
              @selection-change="handleSelectionChange">
              <el-table-column
                type="selection">
              </el-table-column>
              <el-table-column
                prop="name.String"
                label="名称"
              >
              </el-table-column>
              <el-table-column
                prop="burl.String"
                label="Logo"
                width="140px">
                <template slot-scope="scope">
                  <div v-if="scope.row.burl.Valid" >
                    <img :src="scope.row.burl.String" class="avatarimg">
                  </div>
                  <div v-else>
                    {scope.row.burl.String}
                  </div>
              </template>
              </el-table-column>
              <el-table-column
                prop="slogan.String"
                label="标志语">
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                class-name="outopicondiv"
              >
                <template slot-scope="scope">
                  <div class="inopicondiv">
                    <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="edit(scope.$index, goodsbrandtb)"> 编辑 </i>
                    <i class="fa fa-trash-o opicon curpointer" v-on:click="remove(scope.$index, goodsbrandtb)"> 删除 </i>
                  </div>
                </template>
              </el-table-column>
            </el-table>

          </div>
          <el-pagination
            ref="elpage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[size]"
            :page-size=size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </el-col>
      </el-row>
    </div><!--/.row-->
    <el-dialog title="品牌添加" :visible.sync="brandformvisible">
      <el-form :model="form">
        <el-form-item label="品牌名称" :label-width="formLabelWidth">
          <el-input v-model="form.name"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="品牌Logo" :label-width="formLabelWidth" class="yyzz_upload">
          <el-upload
            class="avatar-uploader"
            drag
            action="https://api.sqnetsoft.cn/ossupload/uploadoss"
            :data="upbrandparams"
            :show-file-list = false
            :on-success="OnBrandSuccess"
            :on-error="OnBrandError"
            :before-upload="BeforeBrandUpload">
            <img v-if="brandimgurlok" :src="brandimgurl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item class="el-form-item1" label="宣传语" :label-width="formLabelWidth">
          <el-input type="textarea" v-model="form.slogan" auto-complete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="brandformvisible = false">取 消</el-button>
        <el-button type="primary" @click="savedata">保 存</el-button>
      </div>
    </el-dialog>

  </div>

</template>
<script>
import { Message, Loading } from 'element-ui'
import '../../../static/css/my.css'
var that
var curpagedata
var curdata
export default {
  name: 'GoodsBrand',
  mounted: function () {
    console.log('mounted')
    console.log('开始创建')
    let loadingInstance1 = Loading.service({ fullscreen: true })
    var menudata = this.$parent.$children[1].$refs.menu_data
    console.log(menudata)
    menudata.activeIndex = '115'
    var v = getCookie('cusid')
    this.khid = v
    that = this
    that.upbrandparams = {
      bucketname: 'sqpro',
      bucketpath: 'ecomm/brands'
    }
    if (that.khid === null) {
      loadingInstance1.close()
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
      loadingInstance1.close()
      var idstr = 'cusid = ' + this.khid
      that = this
      that.size = 5
      var goodsbrand = JSON.parse(localStorage.getItem('goodsbrand'))
      if (goodsbrand === null) {
        let loadingInstance1 = Loading.service({ fullscreen: true })
        console.log('开始读取网络数据')
        that.$http.post('https://api.sqnetsoft.cn/goods/qgb', {
          whereinfo: {String: idstr, Valid: true}
        }, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          }
        })
          .then(function (res) {
            console.log('已获取网络数据')
            loadingInstance1.close()
            if (res.data.success === true) {
              localStorage.setItem('goodsbrand', res.data.data)
              curdata = JSON.parse(localStorage.getItem('goodsbrand'))
              curpagedata = new Array(that.size)
              console.log(curdata)
              curpagedata.splice(0, that.size)
              that.total = curdata.length
              for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
                if (curdata[i] != null) {
                  curpagedata.push(curdata[i])
                }
              }
              that.goodsbrandtb = JSON.parse(JSON.stringify(curpagedata))
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      } else {
        console.log('从本地读取')
        var goodsbrandstate = localStorage.getItem('goodsbrandstate')
        if (goodsbrandstate === '0') {
          that.$message({
            type: 'info',
            message: '您上次保存失败，请重新保存！'
          })
        }
        curpagedata = new Array(this.size)
        curdata = JSON.parse(localStorage.getItem('goodsbrand'))
        curpagedata.splice(0, this.size)
        that.total = curdata.length
        for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
          if (curdata[i] != null) {
            curpagedata.push(curdata[i])
          }
        }
        that.goodsbrandtb = JSON.parse(JSON.stringify(curpagedata))
      }
      if (curdata) {
        that.$refs.elpage.count = 0
      } else {
        that.$refs.elpage.count = curdata.length
      }
    }
  },
  data () {
    return {
      goodsbrandtb: JSON.parse(localStorage.getItem('goodsbrand')),
      khid: '',
      querystr: '',
      query_brand: '',
      cur_brandid: '',
      dialogTableVisible: false,
      brandformvisible: false,
      brandimgurlok: false,
      brandimgurl: '',
      form: {
        name: '',
        slogan: ''
      },
      formLabelWidth: '120px',
      editmodel: false,
      multipleSelection: [],
      currentPage: 1,
      total: 0,
      curpage: 1,
      size: 10,
      upbrandparams: '',
      loading: false
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log('每页' + val + '条')
    },
    handleCurrentChange (val) {
      console.log('当前页: ' + val)
      this.curpage = val
      curpagedata.splice(0, this.size)
      for (var i = (that.curpage - 1) * this.size; i < (that.curpage - 1) * this.size + this.size; i++) {
        if (curdata[i] != null) {
          curpagedata.push(curdata[i])
        }
      }
      that.goodsbrandtb = JSON.parse(JSON.stringify(curpagedata))
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    OnBrandError (res) {
      console.log(res)
    },
    OnBrandSuccess (res, file, fileList) {
      console.log(res)
      console.log(file)
      console.log(fileList)
      console.log(res.success)
      if (res.success) {
        this.brandimgurlok = true
        console.log(res.data[0].osspath)
        this.brandimgurl = res.data[0].osspath
      }
      Message.success('上传成功，已上传至OSS存储')
    },
    BeforeBrandUpload (file) {
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    append () {
      // 清空数据
      this.form.name = ''
      this.form.slogan = ''
      this.editmodel = false
      this.brandformvisible = true
      this.brandimgurlok = false
      this.brandimgurl = ''
    },
    savedata () {
      // 获取添加的数据
      var adata
      if (this.editmodel) {
        adata = {
          id: {Int64: parseInt(this.cur_brandid), Valid: true},
          name: {String: this.form.name, Valid: true},
          burl: {String: this.brandimgurl, Valid: true},
          slogan: {String: this.form.slogan, Valid: true},
          cusid: parseInt(this.khid)
        }
      } else {
        adata = {
          name: {String: this.form.name, Valid: true},
          burl: {String: this.brandimgurl, Valid: true},
          slogan: {String: this.form.slogan, Valid: true},
          cusid: parseInt(this.khid)
        }
      }
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/aaugb',
        method: 'post',
        data: adata,
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success === true) {
            var idstr = 'cusid = ' + that.khid
            that.$http.post('https://api.sqnetsoft.cn/goods/qgb', {
              whereinfo: {String: idstr, Valid: true}
            }, {
              headers: {
                'Content-Type': 'application/json;charset=utf-8'
              }
            })
              .then(function (res) {
                console.log('已获取网络数据')
                if (res.data.success === true) {
                  localStorage.setItem('goodsbrand', res.data.data)
                  curdata = JSON.parse(localStorage.getItem('goodsbrand'))
                  that.$message({
                    type: 'success',
                    message: '已成功保存！'
                  })
                  curpagedata = new Array(that.size)
                  console.log(curdata)
                  curpagedata.splice(0, that.size)
                  that.total = curdata.length
                  for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
                    if (curdata[i] != null) {
                      curpagedata.push(curdata[i])
                    }
                  }
                  that.goodsbrandtb = JSON.parse(JSON.stringify(curpagedata))
                  that.brandformvisible = false
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    editdata () {
      this.editmodel = true
    },
    edit (index, data) {
      this.editmodel = true
      // 显示编辑页面
      this.brandformvisible = true
      console.log(data)
      // 获取当前选择数据
      var curselectdata = data[index]
      // 呈现当前选中数据
      console.log(curselectdata)
      // 赋值到当前编辑页面
      this.cur_brandid = curselectdata.id.Int64
      this.form.name = curselectdata.name.String
      if (curselectdata.burl.Valid) {
        this.brandimgurlok = true
        this.brandimgurl = curselectdata.burl.String
      } else {
        this.brandimgurlok = false
      }
      if (curselectdata.slogan.Valid) {
        this.form.slogan = curselectdata.slogan.String
      } else {
        this.form.slogan = ''
      }
    },
    remove (index, data) {
      // 获取当前需要删除的数据
      var curselectdata = data[index]
      // 从数据源中查找该数据的索引
      var dataindex = curdata.findIndex(d => d.id === curselectdata.id)
      // 移除该条数据
      curdata.splice(dataindex, 1)
      var qstr = 'id=' + curselectdata.id.Int64
      this.loading = true
      // 提交到后台服务器做处理
      that.$http({
        url: 'https://api.sqnetsoft.cn/goods/dgb',
        method: 'post',
        data: {
          whereinfo: {'String': qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success === true) {
            that.loading = false
            var idstr = 'cusid = ' + that.khid
            that.$http.post('https://api.sqnetsoft.cn/goods/qgb', {
              whereinfo: {String: idstr, Valid: true}
            }, {
              headers: {
                'Content-Type': 'application/json;charset=utf-8'
              }
            })
              .then(function (res) {
                console.log('已获取网络数据')
                if (res.data.success === true) {
                  localStorage.setItem('goodsbrand', res.data.data)
                  curdata = JSON.parse(localStorage.getItem('goodsbrand'))
                  that.$message({
                    type: 'success',
                    message: '删除成功！'
                  })
                  curpagedata = new Array(that.size)
                  console.log(curdata)
                  curpagedata.splice(0, that.size)
                  that.total = curdata.length
                  for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
                    if (curdata[i] != null) {
                      curpagedata.push(curdata[i])
                    }
                  }
                  that.goodsbrandtb = JSON.parse(JSON.stringify(curpagedata))
                  that.brandformvisible = false
                }
              })
              .catch(function (error) {
                console.log('error' + error)
              })
          } else {
            that.loading = false
            that.$message({
              type: 'error',
              message: '删除失败'
            })
          }
        })
        .catch(function (error) {
          that.loading = false
          that.$message({
            type: 'error',
            message: '删除失败'
          })
          console.log('error' + error)
        })
    },
    queryinfo () {
      var qstr = 'cusid = ' + this.khid
      if (this.query_brand !== null && this.query_brand !== '') {
        qstr = qstr + " and name like '%" + this.query_brand + "%' "
      }
      that.$http.post('https://api.sqnetsoft.cn/goods/qgb', {
        whereinfo: {String: qstr, Valid: true}
      }, {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
        .then(function (res) {
          console.log('已获取网络数据')
          if (res.data.success === true) {
            localStorage.setItem('goodsbrand', res.data.data)
            curdata = JSON.parse(res.data.data)
            curpagedata = new Array(that.size)
            console.log(curdata)
            curpagedata.splice(0, that.size)
            that.total = curdata.length
            for (var i = (that.curpage - 1) * that.size; i < (that.curpage - 1) * that.size + that.size; i++) {
              if (curdata[i] != null) {
                curpagedata.push(curdata[i])
              }
            }
            that.goodsbrandtb = JSON.parse(JSON.stringify(curpagedata))
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/goods/GoodsBrand.vue